export default __webpack_public_path__ + "static/media/portrait11.c9f95f35.jpeg";